<template>
  <LayoutAdmin>
    <section class="w-full px-8 mt-6">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center">
          <h1 class="text-lg md:text-2xl">Output File</h1>
        </div>
        <Button class="px-6 py-2 mx-2 text-white rounded bg-primary h-max" @click="openModal('create')">Add Output
          File</Button>
      </div>
    </section>
    <section class="relative w-full p-4 mb-4">
      <Loading v-if="isLoading" />
      <TableOutputFile :output-files="outputFiles" @on-edit="editTypeFile" @on-delete="deleteOuputFile" />
      <NoDataShowing v-if="outputFiles.length === 0 && isLoading" />
    </section>
  </LayoutAdmin>
  <ModalForm v-show="modal.show" :title="modal.title" :id="formOutputFile.id" :description="formOutputFile.description"
    :type-file="formOutputFile.typeFile" :type-files="typeFiles"
    @update:description="(value) => (formOutputFile.description = value)"
    @update:type-file="(value) => (formOutputFile.typeFile = value)" @on-close="closeModal" @on-submit="submitTypeFile" />
</template>

<script>
import { ref } from "vue";
import { useToast } from "vue-toastification";
import Swal from "sweetalert2";
import {
  getOutputFile,
  createOutputFile,
  updateOutputFile,
  deleteOutputFile,
} from "@/actions/output-file";
import LayoutAdmin from "@/components/Layout/Admin.vue";
import TableOutputFile from "@/components/OutputFile/TableOutputFile.vue";
import NoDataShowing from "@/components/NoDataShowing.vue";
import Loading from "@/components/Loading.vue";
import ModalForm from "@/components/OutputFile/ModalFormOutputFile.vue";

export default {
  name: "OutputFile",
  components: {
    LayoutAdmin,
    TableOutputFile,
    NoDataShowing,
    Loading,
    ModalForm,
  },
  data() {
    return {
      activePeriodic: "-",
    }
  },
  setup() {
    const toast = useToast();
    const outputFiles = ref([]);
    const isLoading = ref(false);
    const modal = ref({
      title: "",
      show: false,
    });
    const formOutputFile = ref({
      id: null,
      description: "",
      typeFile: "",
    });
    const typeFiles = ref([
      { value: "csv", label: "Csv" },
      { value: "excel", label: "Excel" },
    ]);
    return {
      toast,
      outputFiles,
      isLoading,
      modal,
      formOutputFile,
      typeFiles,
    };
  },
  mounted() {
    this.getOutputFile();
  },
  methods: {
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.dataCompany?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
    async getOutputFile() {
      this.isLoading = true;
      const { data, success, code, message } = await getOutputFile();
      if (success) {
        this.outputFiles = data;
        this.isLoading = false;
      } else {
        if (code === 404) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    openModal(value) {
      this.modal.title = value;
      this.modal.show = true;
    },
    closeModal() {
      this.modal.title = "";
      this.modal.show = false;
      this.formOutputFile = {
        description: "",
      };
    },
    editTypeFile(value) {
      this.openModal("edit");
      this.formOutputFile.id = value._id;
      this.formOutputFile.description = value.description;
      this.formOutputFile.typeFile = value.type_file;
    },
    submitTypeFile() {
      const payload = {
        description: this.formOutputFile.description,
        type_file: this.formOutputFile.typeFile,
      };
      if (this.formOutputFile.id !== null) {
        this.updateOutputFile(payload);
      } else {
        this.createOutputFile(payload);
      }
    },
    async createOutputFile(payload) {
      this.isLoading = true;
      const { message, success, code, errors } = await createOutputFile(
        payload
      );
      if (success) {
        this.toast.success("Created output file successfully");
        this.modal.title = "";
        this.modal.show = false;
        this.isLoading = false;
        this.getOutputFile();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code == 400) {
          errors.map((error) => {
            const key = Object.keys(error)[0];
            this.toast.error(error[key]);
          });
        } else {
          this.toast.error(message);
        }
      }
    },
    async updateOutputFile(payload) {
      const { message, success, code, errors } = await updateOutputFile({
        id: this.formOutputFile.id,
        payload,
      });
      if (success) {
        this.toast.success("Updated output file successfully");
        this.modal.title = "";
        this.modal.show = false;
        this.getOutputFile();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else if (code == 400) {
          errors.map((error) => {
            const key = Object.keys(error)[0];
            this.toast.error(error[key]);
          });
        } else {
          this.toast.error(message);
        }
      }
    },
    async deleteOuputFile(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "For delete this data",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { success, code, message } = await deleteOutputFile(id);
          if (success) {
            this.toast.success("Deleted output file successfully");
            this.getOutputFile();
          } else {
            if (code === 401) {
              return this.$router.push("/login");
            } else {
              this.toast.error(message);
            }
          }
        }
      });
    },
  },
};
</script>
